  (function() {
    window.CartPage = window.CartPage || new function() {
    //runs once per page load
    var self = this;
    
    self.updateCart = function() {
      $s.showLoadingOverlay();
      $s.getJson({url: '/?sections=cart_content', success: function(data){
        var section = document.querySelector('.cart-content');
        $s.updateDynamicContent(section, data['cart_content']);
        var summaryWrapper = document.querySelector('#cart .summary-column');
        if (section.querySelector('.cart-items')) {
          summaryWrapper.style.display = '';
        } else {
          summaryWrapper.style.display = 'none';
        }
        $s.globalEval(data['cart_content']);
        $s.hideLoadingOverlay();
      }});
      location.reload();
    }

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    }

    function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function() {
          //overlay reopened by updateCart()
          //$s.hideLoadingOverlay();
          self.updateCart();
        },
        error: $s.addToCartFail
      });
    }
  
  };
  //runs every time #cart div is replaced
  var cart = document.getElementById('cart');
  var itemsCount = 0;
  cart.querySelectorAll('.quantity-box input[type=number]').forEach(function(item){
    itemsCount += item.value/1;
  });
  // var cartCountElement = document.querySelector('header .cart-count');
  // if(cartCountElement) {
  //   cartCountElement.innerHTML = itemsCount>0?itemsCount:'';
  // }

  cart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      const itemPropLabel = this.closest('.item').querySelector('.property .label').innerHTML;
      const itemBundleId = this.closest('.item').querySelector('.property .label-end').innerHTML;
      const removeArray = [];
      if(itemPropLabel.includes("bundle_id:")){
        const props = document.querySelectorAll('.label-end');
        props.forEach(item => {
          const propValue = item.innerHTML;
          
          if (item.innerHTML === itemBundleId){
            console.log(item.closest('.item'));
            removeArray.push(item.closest('.item'));
          }
        })
      }

      CartPage.updateItemsQuantity(removeArray, 0);
    });
  });

  cart.querySelectorAll('input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      CartPage.updateItemsQuantity([this.closest('.item')], this.value);
    });
  });document.querySelectorAll('.details button').forEach((element)=>{
    element.addEventListener('click', function(e){
      e.preventDefault();
      if(element.classList.contains('active')){
        element.classList.remove('active');
        document.getElementById(element.dataset.itemId).classList.remove('show');
      } else {
        element.classList.add('active');
        document.getElementById(element.dataset.itemId).classList.add('show');
      }
      
      console.log('click details');
    });
  });

})();